export const DEFAULT_ROUTE = '/'
export const LOGIN_ROUTE = '/login'
export const NO_PERMISSION_ROUTE = '/no-permission'
